import CacheCleaner from "./CacheCleaner"
import CacheManager from "../CacheManager"

export default class NoteCleaner extends CacheCleaner {

	async onMutation(note_ids, columns) {
		await CacheManager.inst().onObjectsMutation('horse_note', note_ids, columns)
	}
}
